import * as signalR from '@microsoft/signalr';

export class SignalRHttpCLient extends signalR.DefaultHttpClient {

  private callback: () => Promise<string>;

  constructor(callback: () => Promise<string>) {
    super(console); // the base class wants a signalR.ILogger

    this.callback = callback;
  }

  public override async send(request: signalR.HttpRequest): Promise<signalR.HttpResponse> {
    const authHeaders = await this.getAuthHeadersAsync();
    request.headers = { ...request.headers, ...authHeaders };

    try {
      const response = await super.send(request);
      return response;
    } catch (er) {
      if (er instanceof signalR.HttpError) {
        const error = er as signalR.HttpError;
        if (error.statusCode == 401) {
          //token expired - trying a refresh via refresh token
          const authHeaders = await this.getAuthHeadersAsync();
          request.headers = { ...request.headers, ...authHeaders };
        }
      } else {
        throw er;
      }
    }
    //re try the request
    return super.send(request);
  }

  private async getAuthHeadersAsync(): Promise<any> {
    return {
      Authorization: `Bearer ${await this.callback()}`,
    };
  };

}
